<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')">
            <i class="icon-close"></i>
          </a>
          <h3 :key="`InfoAdjustment-Detail-h3-${record.id}`" class="modal-title">要保人{{record.name| getMaskName}}錯誤/共用明細查詢</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:220px;">
          <div class="form-group mt-3">
            <table class="table datatable table-striped area-list-datatable">
              <thead>
                <tr>
                  <th width="*">姓名</th>
                  <th width="*">身分證</th>
                  <th width="*">手機/錯誤共用</th>
                  <th width="*">EMAIL/錯誤共用</th>
                  <th width="*">收費地址/錯誤共用</th>
                  <th width="*">變更申請書</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="`InfoAdjustment-Detail-tr-${record.id}`">
                  <td width="*" style="padding:10px;">{{record.name | getMaskName}}</td>
                  <td width="*">{{record.id | getMaskID}}</td>
                  <td width="*">
                    <span v-if="record.multi_mobl||record.error_mobl||record.mobl_adj_item_name">
                      <span v-if="record.multi_mobl">
                        {{record.multi_mobl}}
                        <br />
                      </span>
                      <span v-if="record.error_mobl">
                        {{record.error_mobl}}
                        <br />
                      </span>
                      <span
                        style="color:red;"
                        v-if="record.mobl_adj_item_name && record.mobl_adj_item_code!='0'"
                      >
                        {{record.mobl_adj_item_name}}
                        <br />
                      </span>
                      <span v-else>— —</span>
                    </span>
                    <span v-else>— —</span>
                  </td>
                  <td width="*">
                    <span v-if="record.multi_email||record.error_email||record.mail_adj_item_name">
                      <span v-if="record.multi_email">
                        {{record.multi_email}}
                        <br />
                      </span>
                      <span v-if="record.error_email">
                        {{record.error_email}}
                        <br />
                      </span>
                      <span
                        style="color:red;"
                        v-if="record.mail_adj_item_name && record.mail_adj_item_code!='0'"
                      >
                        {{record.mail_adj_item_name}}
                        <br />
                      </span>
                      <span v-else>— —</span>
                    </span>
                    <span v-else>— —</span>
                  </td>
                  <td width="*">
                    <span v-if="record.multi_addr||record.error_addr||record.addr_adj_item_name">
                      <span v-if="record.multi_addr">
                        {{record.multi_addr}}
                        <br />
                      </span>
                      <span v-if="record.error_addr">
                        {{record.error_addr}}
                        <br />
                      </span>
                      <span
                        style="color:red;"
                        v-if="record.addr_adj_item_name && record.addr_adj_item_code!='0'"
                      >
                        {{record.addr_adj_item_name}}
                        <br />
                      </span>
                      <span v-else>— —</span>
                    </span>
                    <span v-else>— —</span>
                  </td>
                  <td width="*">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="download()"
                      v-html="'<span style=\'font-size:1.25rem\'>紙本列印<span>'"
                    ></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <span>
            請務必確認客戶資料正確性，可能遇到的狀況(如：確認後資料正確)，
            <br />相關回報說明請點選名單上方迴紋針圖示下載教案查看
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { downloadFile_m0 } from "@/service";
import { saveAs } from "file-saver";

export default {
  name: "InfoAdjustmentDetail",
  mixins: [commonMixin],
  components: {},
  props: {
    record: {
      // 客戶list 資料
      type: Object,
      default: () => {
        return null;
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {
      // 專區資訊
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dtData: [],
      nameBir: "",
      edit: false
    };
  },
  watch: {
    open(val) {
      if (val) {
        this.Init();
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    Init() {
      // 初始化
      this.registerHanlink(); // for 難字更新
    },
    download() {
      if (this.$store.state.userInfo.userType === "box") {
        //若?嵌於Box, 將檔案資訊回傳給Box
        this.boxDownload(
          "Communication_Change_Application.pdf",
          this.catInfo.ser_no
        );
      } else {
        let vm = this;
        downloadFile_m0(
          this.$store.state.userInfo.id,
          this.catInfo.ser_no,
          "Communication_Change_Application.pdf"
        ).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            saveAs(result, "Communication_Change_Application.pdf");
          }
        });
      }
    }
  }
};
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.non-select-arrow {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new {
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}
</style> 